import { useCallback, type FC } from "react";
import {
  Card,
  CardContent,
  Unstable_Grid2 as Grid,
  Avatar,
  Typography,
  Stack,
  CardActionArea,
} from "@mui/material";
import { Profile } from "src/types/analysis";
import { api } from "src/config";

interface SimilarAccountsProps {
  profiles: Profile[];
}

export const SimilarAccounts: FC<SimilarAccountsProps> = (props) => {
  const { profiles } = props;

  const getImageUrl = useCallback((url: string) => {
    return `${api}/image/download?url=` + encodeURIComponent(url);
  }, []);

  return (
    <>
      <Grid
        container
        spacing={3}
        alignItems="stretch"
      >
        {profiles.slice(0, 8).map((profile, index) => (
          <Grid
            xs={6}
            sm={6}
            md={3}
            key={index}
          >
            <Card
              sx={{
                cursor: "pointer",
                height: "100%",
              }}
              onClick={() =>
                window.open(
                  "https://instagram.com/" + profile.username,
                  "_blank"
                )
              }
            >
              <CardActionArea
                sx={{
                  height: "100%",
                }}
              >
                <CardContent
                  sx={{
                    height: "100%",
                  }}
                >
                  <Stack
                    spacing={1}
                    alignItems="center"
                    sx={{}}
                  >
                    <Avatar
                      src={getImageUrl(profile.profilePicUrl)}
                      sx={{ width: 64, height: 64 }}
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        textAlign: "center",
                        wordWrap: "break-word",
                        textWrap: "wrap",
                        width: "100%",
                      }}
                    >
                      {profile.fullName}
                    </Typography>
                    <Typography
                      variant="body2"
                      color={"textSecondary"}
                    >
                      {profile.username}
                    </Typography>
                  </Stack>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
};
